import React, { Fragment, useState, useEffect } from 'react';
import Tippy from '@tippyjs/react';
import $ from 'jquery';
import PageGeneratedQuestionsModal from './PageGeneratedQuestionsModal';
import { getApiPageAnsweredQuestionsUrl, getApiPageQuestionsUrl } from '../../utilities/urlHelper';
import editorStateToText from '../../tettra-editor/utilities/editorStateToText';
import getParamsFromSearchURL from '../../utilities/getParamsFromSearchURL';
import { pluralText } from '../../utilities/wordUtilities';
import { hasKaiFeature } from '../../utilities/featureHelper';

const PageGeneratedQuestionsContainer = (props) => {
    const urlParams = getParamsFromSearchURL(window.location.search);
    const [questions, setQuestions] = useState(null);
    const [answeredQuestions, setAnsweredQuestions] = useState(null);
    const [showPageQuestionsModal, setShowPageQuestionsModal] = useState(urlParams['questions-modal'] === true);
    const [contentLength, setContentLength] = useState(0);

    let questionActiveRequest = null;
    let answeredQuestionActiveRequest = null;

    useEffect(() => {
        getQuestions();
        getAnsweredQuestions();
        getContentLength();
        return (() => {
            if (questionActiveRequest) {
                questionActiveRequest.abort();
            }
        });
    }, [props.page]);

    const getContentLength = () => {
        if (!props.page || !props.page.editor_state) return;
        const content = editorStateToText(JSON.parse(props.page.editor_state));

        // empty page content will be '""', so check if there's still text when we replace all double quotes
        content.replaceAll('"', '').length > 0
            ? setContentLength(content.split(' ').length)
            : setContentLength(0);
    };

    const getQuestions = () => {
        if (!props.page || !props.page.id) return;
        if (!hasKaiFeature()) return;
        setQuestions(null);

        if (questionActiveRequest) {
            questionActiveRequest.abort();
        }

        questionActiveRequest = $.get(getApiPageQuestionsUrl(props.page.id));

        return questionActiveRequest
            .done(({ questions }) => {
                setQuestions(questions);
            });
    };

    const getAnsweredQuestions = () => {
        if (!props.page || !props.page.id) return;
        setAnsweredQuestions(null);

        if (answeredQuestionActiveRequest) {
            answeredQuestionActiveRequest.abort();
        }

        answeredQuestionActiveRequest = $.get(getApiPageAnsweredQuestionsUrl(props.page.id));

        return answeredQuestionActiveRequest
            .done(({ answeredQuestions }) => {
                setAnsweredQuestions(answeredQuestions);
            });
    };

    if (!questions && !answeredQuestions
        || (!Array.isArray(questions) && !Array.isArray(answeredQuestions))
    ) return null;

    const tooltipText = 'View Questions';

    let questionCount;
    if (hasKaiFeature()) {
        questionCount = questions && answeredQuestions && questions.length + answeredQuestions.length;
    } else {
        questionCount = answeredQuestions && answeredQuestions.length;
    }
    const questionText = pluralText(questionCount, 'Question');

    return (
        <Fragment>
            <Tippy content={tooltipText} placement="bottom">
                <button
                    className="insights"
                    onClick={() => {
                        setShowPageQuestionsModal(true);
                    }}
                    aria-label="view page questions"
                    type="button"
                >
                    {/* <img
                        className="bot-avatar left"
                        src="/img/kai.png"
                        width="24"
                        height="24"
                        style={{ margin: '-3px 0' }}
                        alt="Kai"
                    /> */}
                    <span role="img" aria-hidden="true">❓</span>
                    {`${questionText}`}
                </button>
            </Tippy>
            { showPageQuestionsModal
                && (
                    <PageGeneratedQuestionsModal
                        questions={questions}
                        answeredQuestions={answeredQuestions}
                        pageId={props.page.id}
                        pageVisibility={props.page.visibility}
                        pageContentLength={contentLength}
                        closeModal={() => setShowPageQuestionsModal(false)}
                        updateQuestions={setQuestions}
                    />
                )}
        </Fragment>
    );
};

export default PageGeneratedQuestionsContainer;
